import { createSelector } from 'reselect';
export const TYPING_DURATION = 3e3;
export const getTypingUsers = createSelector((state) => state.chat.typing, (state) => state.users, (typings, users) => {
    const result = typings.map(userId => users.map[userId]).filter(Boolean);
    return result;
});
